import { render, staticRenderFns } from "./Listado-docentes.vue?vue&type=template&id=8c3ef12a"
import script from "./Listado-docentes.vue?vue&type=script&lang=js"
export * from "./Listado-docentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports